export const normalizeCustomerTag = (value) => {
  if (value === null || value === undefined) return null;
  const str = String(value).trim();
  return str || null;
};

const collectTagCandidates = (source) => {
  if (!source || typeof source !== 'object') return [];
  return [
    source.customerTag,
    source.customer_tag,
    source.client_tag,
    source.tag,
    source.client?.tag,
    source.customer?.tag,
    source.contact?.tag,
  ];
};

export const resolveCustomerTag = (source, fallback) => {
  const candidates = collectTagCandidates(source);
  for (const candidate of candidates) {
    const normalized = normalizeCustomerTag(candidate);
    if (normalized) return normalized;
  }

  if (typeof fallback === 'string') {
    return normalizeCustomerTag(fallback);
  }

  if (fallback && fallback !== source) {
    return resolveCustomerTag(fallback);
  }

  return null;
};
